var map = {
	"./dapeng.png": "a27b",
	"./icon.png": "b911",
	"./icon3.png": "4730",
	"./ji.png": "743a",
	"./xuexiao.png": "cb59",
	"./xumuye.png": "29b1",
	"./yang.png": "d40c",
	"./yiyuan.png": "956b",
	"./zhu.png": "fa85"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "68cd";